'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _YesNoStatus = require('components/YesNoStatus/YesNoStatus');

var _YesNoStatus2 = _interopRequireDefault(_YesNoStatus);

var _RecipientShareLinkButton = require('components/Statistics/RecipientShareLinkButton/RecipientShareLinkButton');

var _RecipientShareLinkButton2 = _interopRequireDefault(_RecipientShareLinkButton);

var _ExpiryDate = require('components/ExpiryDate/ExpiryDate');

var _ExpiryDate2 = _interopRequireDefault(_ExpiryDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./RecipientProjectsListItem.scss');

var RecipientProjectsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(RecipientProjectsListItem, _PureComponent);

  function RecipientProjectsListItem() {
    (0, _classCallCheck3.default)(this, RecipientProjectsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientProjectsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientProjectsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientProjectsListItem, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          project = _props.project,
          onClick = _props.onClick;

      onClick(project);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          project = _props2.project,
          recipientId = _props2.recipientId,
          showShare = _props2.showShare;


      return _react2.default.createElement(
        _ListItem2.default,
        { fullWidth: true, className: (0, _bind2.default)('cursor-pointer', className), onClick: this.onClick },
        _react2.default.createElement(
          'div',
          null,
          project.id
        ),
        _react2.default.createElement(
          'div',
          null,
          project.fullTitle
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_YesNoStatus2.default, { success: !!project.played, hasRights: true })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_YesNoStatus2.default, { success: !!project.downloaded, hasRights: !!project.download })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ExpiryDate2.default, { dateText: project.expiryDateText, isExpired: project.isExpired })
        ),
        showShare && _react2.default.createElement(
          'div',
          { className: styles.shareButtonCell },
          _react2.default.createElement(_RecipientShareLinkButton2.default, { className: styles.shareButton, recipientId: recipientId, projectId: project.id })
        )
      );
    }
  }]);
  return RecipientProjectsListItem;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  project: _propTypes2.default.object,
  recipientId: _propTypes2.default.number,
  showShare: _propTypes2.default.bool
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  project: {},
  showShare: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = RecipientProjectsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientProjectsListItem/RecipientProjectsListItem.js
// module id = 2120
// module chunks = 1